import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import util from "../util/util";

export default function RuleFormTimeSlots(props) {
  return (
    <div>
      <div className="rule-form__timeslots-row">
        <div className="rule-form__timeslots-col--select">
          <div className="form-group">
            <label className="control-label" htmlFor="timeslotsAvailable">
              Unselected Slots
            </label>
            <select
              id="timeslotsAvailable"
              className="form-control"
              multiple
              size="10"
            >
              {_.difference(util.timeSlots, props.value).map(
                (timeSlot, index) => {
                  return (
                    <option value={timeSlot} key={index}>
                      {timeSlot}
                    </option>
                  );
                }
              )}
            </select>
          </div>
        </div>

        <div className="rule-form__timeslots-col--buttons">
          <p className="text-center">
            <button
              type="button"
              className="btn btn-default"
              onClick={() => {
                const select = document.querySelector(`#timeslotsAvailable`);
                const options = select.selectedOptions;
                const optionsArray = [].slice
                  .call(options)
                  .map(option => option.value);

                select.value = null;

                props.onChange(props.value.concat(optionsArray).sort());
              }}
            >
              Add
              <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </p>

          <p className="text-center">
            <button
              type="button"
              className="btn btn-default"
              onClick={() => {
                const select = document.querySelector(`#timeslotsSelected`);
                const options = select.selectedOptions;
                const optionsArray = [].slice
                  .call(options)
                  .map(option => option.value);

                select.value = null;

                props.onChange(_.difference(props.value, optionsArray).sort());
              }}
            >
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
              Remove
            </button>
          </p>
        </div>

        <div className="rule-form__timeslots-col--select">
          <div className={props.error ? `form-group has-error` : `form-group`}>
            <label className="control-label" htmlFor="timeslotsSelected">
              Selected Slots
            </label>
            <select
              id="timeslotsSelected"
              className="form-control"
              multiple
              size="10"
            >
              {props.value.map((timeSlot, index) => {
                return (
                  <option value={timeSlot} key={index}>
                    {timeSlot}
                  </option>
                );
              })}
            </select>
            <p className={props.error ? `help-block` : `hidden`}>
              Time Slots is a required field.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

RuleFormTimeSlots.propTypes = {
  error: PropTypes.bool, // show the error or not (only one error possible);
  value: PropTypes.array, // selected time slots (all - selected = available);
  onChange: PropTypes.func // run when changing the selected time slots;
};
